/* ======================================================
   EUROTOGA — theme.js
   No external dependencies. Uses Shopify's AJAX Cart API (/cart/add.js, /cart.js, /cart/change.js).

   ------------------------------------------------------------------
   FILE MAP (quick orientation for future maintenance)
   ------------------------------------------------------------------
   - uploadToImgBB()               → uploads measurement photos to ImgBB
                                      (free external service, not Shopify:
                                      needed because Shopify has no native
                                      way for a customer to attach a file
                                      to the cart before checkout).
   - money() / euroClean()         → price formatting. money() respects
                                      Shopify's currency format (shop.
                                      money_format, including any "+VAT"
                                      text set in Admin); euroClean() ignores
                                      that format and always prints a clean
                                      "X.XX €" — used for the configurator's
                                      live total and the price that updates
                                      with the selected variant.
                                      NOTE: the site shows VAT-EXCLUDED prices
                                      only everywhere except the gift card
                                      (which was never VAT-doubled). A dual
                                      net/gross price display existed at one
                                      point and was deliberately reverted —
                                      if it's ever wanted again, it needs to
                                      be rebuilt from scratch (product-card.
                                      liquid, main-product.liquid, both
                                      configurator summaries, main-cart.
                                      liquid), it is NOT just commented out
                                      somewhere waiting to be switched on.
   - EurotogaCart                  → thin wrapper around Shopify's AJAX Cart
                                      API. addItemsAndGoToCart() adds line
                                      items and redirects to the cart page.
                                      There is NO cart drawer (side panel)
                                      anymore — removed because it was never
                                      wired to any HTML; the site always
                                      uses the real /cart page.
   - EurotogaBilling                → "Billing details" popup in the cart,
                                      before checkout. 4 customer types
                                      (Individual/Professional/Company/
                                      Public entity), each with its own
                                      fields. Everything is saved as order
                                      note attributes — unrelated to the
                                      gift card, which has its own separate
                                      native delivery system (see below).
   - initConfigurator()             → the FULL toga configurator (6-7
                                      steps: gender, style, cords,
                                      measurements, embroidery, pettorina/
                                      bib, notes). Used by the "Toga" and
                                      "Uditore Giudiziario" products (the
                                      latter with some steps locked/pre-
                                      filled, see data.isUditore).
   - Gift card (see "gift card" section further down)
                                     → USES Shopify's "reserved" property
                                      names (Recipient email, Recipient
                                      name, Message, Send on, __shopify_
                                      send_gift_card_to_recipient,
                                      __shopify_offset) which trigger
                                      Shopify's native AUTOMATIC email
                                      delivery (including scheduled dates)
                                      — this is not a homegrown system, and
                                      delivery must never be recorded as a
                                      manual note instead: the exact
                                      property names are documented at
                                      shopify.dev/docs/storefronts/themes/
                                      product-merchandising/gift-cards and
                                      must be respected to the letter (they
                                      are case-sensitive) or automatic
                                      delivery silently stops working.
   ------------------------------------------------------------------
====================================================== */
var IMGBB_API_KEY = 'f4f3a005b983b2e4173ffcd6dcfb0a17';

function uploadToImgBB(file) {
  var formData = new FormData();
  formData.append('image', file);
  return fetch('https://api.imgbb.com/1/upload?key=' + IMGBB_API_KEY, {
    method: 'POST',
    body: formData
  }).then(function (r) { return r.json(); }).then(function (res) {
    if (res && res.success && res.data && res.data.url) return res.data.url;
    throw new Error('upload fallito');
  });
}

/* ---------------- utilities ---------------- */
function money(cents, format) {
  format = format || '€{{amount}}';
  var value = (cents / 100).toFixed(2).replace('.', ',');
  var valueNoDecimals = String(Math.round(cents / 100));
  var valueApostrophe = value.replace(',', "'");
  return format
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, valueNoDecimals)
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, valueApostrophe)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDecimals)
    .replace(/\{\{\s*amount\s*\}\}/g, value);
}
// Clean "X,XX €" formatting that deliberately ignores shop.money_format
// (and therefore whatever "+IVA" text is baked into that store-level
// setting) — used everywhere a VAT-excluded price needs a hardcoded
// "iva esclusa"/"+IVA" wording instead. Global on purpose: both the
// standard product page and the toga configurator (two separate script
// scopes) need it.
function euroClean(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}
function rangeOptions(min, max, step, current, placeholder, suffix) {
  suffix = suffix || '';
  var html = '<option value="">' + (placeholder || 'Seleziona') + '</option>';
  for (var v = min; v <= max; v += step) {
    html += '<option value="' + v + '"' + (String(v) === String(current) ? ' selected' : '') + '>' + v + suffix + '</option>';
  }
  return html;
}
function selectOptionsFromList(list, current, placeholder) {
  var html = '<option value="">' + (placeholder || 'Seleziona') + '</option>';
  (list || []).forEach(function (v) {
    var safe = String(v);
    html += '<option value="' + escapeHtml(safe) + '"' + (safe === current ? ' selected' : '') + '>' + escapeHtml(safe) + '</option>';
  });
  return html;
}
function escapeHtml(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function fieldInfoHtml(key, mediaHtml, caption) {
  return '<span class="field-info-wrap">' +
    '<button type="button" class="field-info-btn" data-info-toggle="' + key + '" aria-label="Come si misura">?</button>' +
    '<div class="field-info-popover" id="infoPopover-' + key + '">' +
      '<button type="button" class="field-info-close" data-info-close="' + key + '" aria-label="Chiudi">&times;</button>' +
      mediaHtml +
      (caption ? '<p>' + caption + '</p>' : '') +
    '</div>' +
  '</span>';
}
function bindFieldInfoToggles(container) {
  qsa('[data-info-toggle]', container).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var key = btn.getAttribute('data-info-toggle');
      var pop = document.getElementById('infoPopover-' + key);
      var isOpen = pop && pop.classList.contains('open');
      qsa('.field-info-popover', container).forEach(function (p) { p.classList.remove('open'); });
      if (pop && !isOpen) pop.classList.add('open');
    });
  });
  qsa('[data-info-close]', container).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var key = btn.getAttribute('data-info-close');
      var pop = document.getElementById('infoPopover-' + key);
      if (pop) pop.classList.remove('open');
    });
  });
}
document.addEventListener('click', function () {
  qsa('.field-info-popover.open').forEach(function (p) { p.classList.remove('open'); });
});
// Standalone info icon next to the "craft note" text on the product page
// (e.g. "Toga su misura con arricciatura a cannoncini, realizzata a mano").
// Lives outside #configuratorSteps (which is rebuilt by JS), so it's bound
// once here instead of via bindFieldInfoToggles to avoid double-binding.
document.addEventListener('DOMContentLoaded', function () {
  var craftBtn = document.getElementById('craftNoteInfoBtn');
  var craftPop = document.getElementById('craftNoteInfoPopover');
  var craftClose = document.getElementById('craftNoteInfoClose');
  if (craftBtn && craftPop) {
    craftBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = craftPop.classList.contains('open');
      qsa('.field-info-popover.open').forEach(function (p) { p.classList.remove('open'); });
      if (!isOpen) craftPop.classList.add('open');
    });
  }
  if (craftClose && craftPop) {
    craftClose.addEventListener('click', function (e) {
      e.stopPropagation();
      craftPop.classList.remove('open');
    });
  }
});
function heightIllustrationSVG() {
  return '<svg viewBox="0 0 160 220" width="100%" style="max-width:150px; margin:0 auto; display:block;">' +
    // left-side ruler: vertical bar with tick marks
    '<line x1="14" y1="10" x2="14" y2="210" stroke="#A2793A" stroke-width="2.5"/>' +
    '<line x1="6" y1="10" x2="22" y2="10" stroke="#A2793A" stroke-width="2.5"/>' +
    '<line x1="6" y1="210" x2="22" y2="210" stroke="#A2793A" stroke-width="2.5"/>' +
    '<line x1="8" y1="45" x2="20" y2="45" stroke="#A2793A" stroke-width="1.4"/>' +
    '<line x1="8" y1="80" x2="20" y2="80" stroke="#A2793A" stroke-width="1.4"/>' +
    '<line x1="8" y1="115" x2="20" y2="115" stroke="#A2793A" stroke-width="1.4"/>' +
    '<line x1="8" y1="150" x2="20" y2="150" stroke="#A2793A" stroke-width="1.4"/>' +
    '<line x1="8" y1="185" x2="20" y2="185" stroke="#A2793A" stroke-width="1.4"/>' +
    // realistic human figure (full silhouette), head to toe
    '<circle cx="95" cy="26" r="18" fill="#16130F"/>' +
    '<path d="M95 44 C74 44 66 58 63 78 L58 118 C57 124 62 128 67 126 L72 100 L72 210 L86 210 L88 128 L102 128 L104 210 L118 210 L118 100 L123 126 C128 128 133 124 132 118 L127 78 C124 58 116 44 95 44 Z" fill="#16130F"/>' +
    '</svg>';
}
function toast(msg) {
  var wrap = document.getElementById('toast-wrap');
  if (!wrap) return;
  var el = document.createElement('div');
  el.className = 'toast';
  el.textContent = msg;
  wrap.appendChild(el);
  setTimeout(function () { el.remove(); }, 3200);
}
function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

/* ---------------- billing details (before checkout) ---------------- */
var EurotogaBilling = (function () {
  var type = null;

  function validateCF(v) {
    return /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/.test(v.replace(/\s/g, ''));
  }

  var FIELDS = {
    privato: [
      { key: 'Codice Fiscale', id: 'bfCf', label: 'Codice fiscale', required: true, placeholder: 'RSSMRA80A01H501U', validate: validateCF, errorMsg: 'Il codice fiscale non è valido.' }
    ],
    professionista: [
      { key: 'Nominativo', id: 'bfRagione', label: 'Nominativo', required: true, placeholder: 'Mario Rossi' },
      { key: 'Codice Fiscale', id: 'bfCf', label: 'Codice fiscale', required: true, placeholder: 'RSSMRA80A01H501U', validate: validateCF, errorMsg: 'Il codice fiscale non è valido.' },
      { key: 'Partita IVA', id: 'bfPiva', label: 'Partita IVA', required: true, placeholder: '12345678901' },
      { key: 'PEC / Codice SDI', id: 'bfPecSdi', label: 'PEC e/o Codice SDI', required: true, placeholder: 'Indirizzo PEC / codice SDI' }
    ],
    impresa: [
      { key: 'Ragione Sociale', id: 'bfRagione', label: 'Ragione sociale', required: true, placeholder: 'Studio Legale Rossi Srl' },
      { key: 'Partita IVA', id: 'bfPiva', label: 'Partita IVA', required: true, placeholder: '12345678901' },
      { key: 'PEC / Codice SDI', id: 'bfPecSdi', label: 'PEC e/o Codice SDI', required: true, placeholder: 'Indirizzo PEC / codice SDI' }
    ],
    pa: [
      { key: 'Denominazione Ente', id: 'bfEnte', label: 'Denominazione ente', required: true },
      { key: 'Codice Fiscale', id: 'bfCfPa', label: 'Codice fiscale', required: false },
      { key: 'Partita IVA', id: 'bfPivaPa', label: 'Partita IVA', required: false },
      { key: 'Codice IPA', id: 'bfIpa', label: 'Codice IPA dell\'Ente', required: true },
      { key: 'Split Payment', id: 'bfSplit', label: 'Soggetto a Split Payment?', required: true, type: 'select', options: ['Sì', 'No'] },
      { key: 'Note', id: 'bfNote', label: 'Note (facoltativo)', required: false, type: 'textarea', placeholder: 'Eventuali indicazioni aggiuntive' }
    ]
  };
  var GROUP_HINT = {};
  var LABELS = { privato: 'Privato', professionista: 'Professionista', impresa: 'Azienda', pa: 'Ente Pubblico / PA' };
  var values = {};

  function open() {
    document.getElementById('billingOverlay').classList.add('open');
    document.getElementById('billingError').style.display = 'none';
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var attrs = cart.attributes || {};
      if (attrs['Tipo cliente']) {
        var savedType = Object.keys(LABELS).filter(function (k) { return LABELS[k] === attrs['Tipo cliente']; })[0];
        if (savedType) {
          type = savedType;
          Object.keys(attrs).forEach(function (k) { values[k] = attrs[k]; });
        }
      }
      renderTypeButtons();
      renderFields();
    });
  }
  function close() {
    document.getElementById('billingOverlay').classList.remove('open');
  }
  function skip() {
    close();
    window.location.href = '/checkout';
  }

  function renderTypeButtons() {
    qsa('#billingTypeRow [data-billing-type]').forEach(function (btn) {
      var t = btn.getAttribute('data-billing-type');
      btn.className = 'choice' + (type === t ? ' selected' : '');
      btn.onclick = function () { type = t; renderFields(); };
    });
  }

  function renderFields() {
    var wrap = document.getElementById('billingFields');
    if (!type) { wrap.innerHTML = ''; renderTypeButtons(); return; }
    var html = '';
    var groupsSeen = {};
    FIELDS[type].forEach(function (f) {
      html += '<div class="field" style="margin-top:14px;"><label for="' + f.id + '">' + f.label + '</label>';
      if (f.type === 'select') {
        html += '<select id="' + f.id + '">' +
          '<option value="">Seleziona</option>' +
          f.options.map(function (opt) {
            return '<option value="' + opt + '"' + (values[f.key] === opt ? ' selected' : '') + '>' + opt + '</option>';
          }).join('') +
          '</select>';
      } else if (f.type === 'textarea') {
        html += '<textarea id="' + f.id + '" placeholder="' + (f.placeholder || '') + '" rows="3" style="width:100%; padding:11px 12px; border:1px solid var(--line); background:var(--paper); font-family:var(--sans); font-size:14px;">' + (values[f.key] || '') + '</textarea>';
      } else {
        html += '<input type="text" id="' + f.id + '" placeholder="' + (f.placeholder || '') + '" value="' + (values[f.key] || '') + '">';
      }
      html += '</div>';
      if (f.group) groupsSeen[f.group] = true;
    });
    Object.keys(groupsSeen).forEach(function (g) {
      if (GROUP_HINT[g]) html += '<p class="hint" style="margin-top:6px;">' + GROUP_HINT[g] + '</p>';
    });
    wrap.innerHTML = html;
    renderTypeButtons();
    // Codice fiscale: il cliente spesso lo scrive minuscolo — lo convertiamo
    // in maiuscolo mentre digita (è così che va sempre scritto, e la
    // convalida del formato si aspetta le lettere maiuscole).
    ['bfCf', 'bfCfPa'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () {
        var start = el.selectionStart, end = el.selectionEnd;
        el.value = el.value.toUpperCase();
        try { el.setSelectionRange(start, end); } catch (e) {}
      });
    });
  }

  function submit() {
    var errEl = document.getElementById('billingError');
    errEl.style.display = 'none';
    if (!type) { errEl.textContent = 'Seleziona chi sta acquistando.'; errEl.style.display = 'block'; return; }
    var attrs = { 'Tipo cliente': LABELS[type] };
    var missing = [];
    var invalid = [];
    var groups = {};

    FIELDS[type].forEach(function (f) {
      var el = document.getElementById(f.id);
      var val = el ? el.value.trim() : '';
      if (val && (f.id === 'bfCf' || f.id === 'bfCfPa')) val = val.toUpperCase();
      if (val) attrs[f.key] = val;

      if (f.group) {
        groups[f.group] = groups[f.group] || [];
        groups[f.group].push({ field: f, val: val });
        return;
      }
      if (f.required && !val) { missing.push(f.label); return; }
      if (val && f.validate && !f.validate(val)) { invalid.push(f.errorMsg || (f.label + ' non è valido.')); }
    });

    Object.keys(groups).forEach(function (g) {
      var items = groups[g];
      var filled = items.filter(function (it) { return it.val; });
      if (filled.length === 0) {
        missing.push(items.map(function (it) { return it.field.label; }).join(' o '));
      } else {
        filled.forEach(function (it) {
          if (it.field.validate && !it.field.validate(it.val)) invalid.push(it.field.errorMsg || (it.field.label + ' non è valido.'));
        });
      }
    });

    if (missing.length || invalid.length) {
      var msgs = [];
      if (missing.length) msgs.push('Compila: ' + missing.join(', ') + '.');
      if (invalid.length) msgs.push(invalid.join(' '));
      errEl.textContent = msgs.join(' ');
      errEl.style.display = 'block';
      return;
    }
    // I dati di fatturazione vivono SOLO nei "Dettagli aggiuntivi"
    // (cart attributes) — non toccano mai il campo "Note" del carrello.
    // Prima si tentava di unire i due (vedi versione precedente), ma è
    // più semplice e più sicuro non toccare affatto la nota: qualunque
    // cosa il cliente scriva lì (prima, durante o dopo aver compilato
    // questo popup) resta sempre esattamente com'è, parola per parola.
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); }).then(function () {
      window.location.href = '/checkout';
    }).catch(function () {
      errEl.textContent = 'Non è stato possibile salvare i dati. Riprova.';
      errEl.style.display = 'block';
    });
  }

  return { open: open, close: close, skip: skip, submit: submit };
})();

document.addEventListener('click', function (e) {
  var el = e.target.closest && e.target.closest('[data-checkout-link]');
  if (!el) return;
  e.preventDefault();
  var termsBox = document.getElementById('cartTermsCheckbox');
  var termsWrap = document.getElementById('cartTermsWrap');
  if (termsBox && termsWrap && !termsBox.checked) {
    termsWrap.classList.add('has-error');
    termsWrap.classList.remove('shake');
    void termsWrap.offsetWidth;
    termsWrap.classList.add('shake');
    termsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    termsBox.focus();
    return;
  }
  EurotogaBilling.open();
});

/* ---------------- measurement guide modal ---------------- */
var EurotogaMeasureGuide = (function () {
  function open() {
    var el = document.getElementById('measureOverlay');
    if (el) el.classList.add('open');
    var video = el ? el.querySelector('video') : null;
    if (video) {
      video.play().catch(function () { /* autoplay blocked by browser, user can press play manually */ });
    }
  }
  function close() {
    var el = document.getElementById('measureOverlay');
    if (el) el.classList.remove('open');
    // Stop the video instead of letting it keep playing in the background
    // after the popup is closed (X button or "Ho capito" both call this).
    var video = el ? el.querySelector('video') : null;
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
  return { open: open, close: close };
})();

/* ---------------- gift card: direct purchase ---------------- */
document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('GiftCardData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var selectedVariant = null;
  var giftSelect = document.getElementById('giftValueSelect');
  var priceDisplay = document.getElementById('giftValueDisplay');
  var giftImage = document.getElementById('giftMainImage');
  function applySelection(variantId, priceAttr) {
    selectedVariant = variantId || null;
    if (priceDisplay && priceAttr != null) priceDisplay.textContent = money(priceAttr, data.moneyFormat);
    if (giftImage) {
      var variantImg = selectedVariant && data.variantImages ? data.variantImages[selectedVariant] : null;
      giftImage.src = variantImg || data.defaultImage || giftImage.src;
    }
  }
  if (giftSelect) {
    // Variant picker as a <select> (see sections/main-product.liquid)
    giftSelect.addEventListener('change', function () {
      var opt = giftSelect.options[giftSelect.selectedIndex];
      applySelection(giftSelect.value, opt ? opt.getAttribute('data-gift-price') : null);
    });
  }
  var giftValueRow = document.getElementById('giftValueRow');
  if (giftValueRow) {
    // Variant picker as buttons (see sections/product-giftcard.liquid —
    // the template actually assigned to the gift card product).
    var giftVariantBtns = qsa('[data-gift-variant]', giftValueRow);
    giftVariantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        giftVariantBtns.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        applySelection(btn.getAttribute('data-gift-variant'), btn.getAttribute('data-gift-price'));
      });
    });
    // Pre-select whichever button starts marked "selected" (first available
    // variant), so the image/price/buy button are correct even before the
    // person clicks anything.
    var preSelected = giftValueRow.querySelector('[data-gift-variant].selected') || giftVariantBtns[0];
    if (preSelected) applySelection(preSelected.getAttribute('data-gift-variant'), preSelected.getAttribute('data-gift-price'));
  }

  var giftMode = false;
  var modeNo = document.getElementById('giftModeNo');
  var modeYes = document.getElementById('giftModeYes');
  var giftFields = document.getElementById('giftFields');
  if (modeNo && modeYes) {
    modeNo.addEventListener('click', function () {
      giftMode = false;
      modeNo.classList.add('selected'); modeYes.classList.remove('selected');
      giftFields.style.display = 'none';
    });
    modeYes.addEventListener('click', function () {
      giftMode = true;
      modeYes.classList.add('selected'); modeNo.classList.remove('selected');
      giftFields.style.display = 'block';
    });
  }

  var buyBtn = document.getElementById('giftBuyNowBtn');
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      if (!selectedVariant) { toast('Scegli un taglio.'); return; }
      var props = {};
      if (giftMode) {
        var rName = document.getElementById('giftRecipientName').value.trim();
        var rEmail = document.getElementById('giftRecipientEmail').value.trim();
        if (!rEmail) { toast('Inserisci l\'email del destinatario.'); return; }
        // Reserved property names that Shopify recognizes for native automatic
        // gift card delivery (docs: shopify.dev/docs/storefronts/themes/
        // product-merchandising/gift-cards). With these exact names Shopify itself
        // sends the email to the recipient, even on a scheduled date, with no
        // manual note or action required from us.
        props['__shopify_send_gift_card_to_recipient'] = 'true';
        props['Recipient email'] = rEmail;
        if (rName) props['Recipient name'] = rName;
        var sName = document.getElementById('giftSenderName').value.trim();
        if (sName) props['Da parte di'] = sName;
        var msg = document.getElementById('giftMessage').value.trim();
        if (msg) props['Message'] = msg;
        var sendDate = document.getElementById('giftSendDate').value;
        if (sendDate) props['Send on'] = sendDate;
        if (typeof Intl !== 'undefined') {
          try { props['__shopify_offset'] = String(new Date().getTimezoneOffset()); } catch (e) {}
        }
      }
      buyBtn.disabled = true;
      buyBtn.textContent = 'Attendere…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariant, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        toast('Non è stato possibile procedere. Riprova.');
        buyBtn.disabled = false;
        buyBtn.textContent = 'Acquista ora';
      });
    });
  }
});

/* ---------------- product gallery: thumbnail switching ---------------- */
document.addEventListener('DOMContentLoaded', function () {
  var thumbs = qsa('.gallery-thumbs .thumb');
  if (!thumbs.length) return;
  var mainImg = document.getElementById('galleryMainImg');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (o) { o.classList.remove('active'); });
      t.classList.add('active');
      var full = t.getAttribute('data-full');
      if (mainImg && mainImg.tagName === 'IMG' && full) mainImg.src = full;
    });
  });
});

/* ---------------- standard product (single cordoni/pettorine/porta-toga) ---------------- */
document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('StandardProductData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var selects = qsa('[data-option-select]');
  var idInput = document.getElementById('StandardProductVariantId');
  var priceWrap = document.getElementById('StandardProductPrice');
  var submitBtn = document.getElementById('StandardProductSubmit');
  var form = document.getElementById('StandardProductForm');

  function currentVariant() {
    var chosen = selects.map(function (s) { return s.value; });
    return data.variants.filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  }

  function updatePrice() {
    var v = currentVariant();
    if (!v) return;
    idInput.value = v.id;
    var html = '<div class="net-row"><span class="now">' + euroClean(v.price).replace(' €', '€') + '</span>';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      html += '<span class="was">' + euroClean(v.compare_at_price).replace(' €', '€') + '</span>';
    }
    html += '<span class="vat-label">iva esclusa</span></div>';
    priceWrap.innerHTML = html;
    submitBtn.disabled = !v.available;
    submitBtn.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
  }

  selects.forEach(function (s) { s.addEventListener('change', updatePrice); });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var qty = parseInt(document.getElementById('Quantity').value, 10) || 1;
      var props = {};
      qsa('[name^="properties["]', form).forEach(function (input) {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match && input.value.trim()) props[match[1]] = input.value.trim();
      });
      submitBtn.disabled = true;
      submitBtn.textContent = 'Aggiunta…';
      EurotogaCart.addItemsAndGoToCart([{ id: v.id, quantity: qty, properties: props }]).catch(function () {
        toast('Non è stato possibile aggiungere al carrello.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Aggiungi al carrello';
      });
    });
  }
});

/* ---------------- header / burger menu ---------------- */
document.addEventListener('DOMContentLoaded', function () {
  var accountToggle = document.getElementById('accountToggle');
  var accountMenu = document.getElementById('accountMenu');
  if (accountToggle && accountMenu) {
    accountToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = accountMenu.classList.contains('open');
      accountMenu.classList.toggle('open', !isOpen);
      accountToggle.setAttribute('aria-expanded', String(!isOpen));
    });
    document.addEventListener('click', function (e) {
      if (!accountMenu.contains(e.target) && e.target !== accountToggle) {
        accountMenu.classList.remove('open');
        accountToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  var burger = document.getElementById('burgerToggle');
  var nav = document.getElementById('mainNav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.contains('mobile-open');
      nav.classList.toggle('mobile-open', !isOpen);
      burger.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  var dropdowns = qsa('.nav-dropdown');
  function closeAllDropdowns(except) {
    dropdowns.forEach(function (d) {
      if (d !== except) {
        d.classList.remove('open');
        var t = d.querySelector('.nav-dropdown-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }
  dropdowns.forEach(function (d) {
    var toggle = d.querySelector('.nav-dropdown-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = d.classList.contains('open');
      closeAllDropdowns(d);
      d.classList.toggle('open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  document.addEventListener('click', function () { closeAllDropdowns(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });
});

/* ---------------- cart helpers (AJAX add + redirect to /cart) ---------------- */
var EurotogaCart = (function () {
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var countEl = document.getElementById('cartCount');
      if (countEl) {
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function addItemsAndGoToCart(items) {
    return addItems(items).then(function (res) {
      window.location.href = '/cart';
      return res;
    });
  }
  return { refresh: refreshCount, addItems: addItems, addItemsAndGoToCart: addItemsAndGoToCart };
})();
document.addEventListener('DOMContentLoaded', function () {
  EurotogaCart.refresh();
});

/* ---------------- cart page: note, terms ---------------- */
document.addEventListener('DOMContentLoaded', function () {
  var removeGroupBtns = document.querySelectorAll('[data-remove-group]');
  removeGroupBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var keys = btn.getAttribute('data-remove-group').split(',').filter(Boolean);
      if (!keys.length) return;
      btn.disabled = true;
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        btn.disabled = false;
        toast('Non è stato possibile rimuovere la configurazione. Riprova.');
      });
    });
  });

  // Quantity fields: no submit button, no confirm dialogs. Changing the
  // number (typing or the native up/down arrows) updates the cart on its
  // own. Never allowed below 1 — to remove an item the person uses the
  // "Rimuovi" link instead, so a value of 0 or blank just snaps back to 1
  // rather than silently deleting the line.
  var qtyInputs = document.querySelectorAll('[data-cart-qty-input]');
  qtyInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      var qty = parseInt(input.value, 10);
      if (!qty || qty < 1) {
        qty = 1;
        input.value = 1;
      }
      input.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        input.disabled = false;
        toast('Non è stato possibile aggiornare la quantità. Riprova.');
      });
    });
  });

  var noteEl = document.getElementById('cartNote');
  if (noteEl) {
    var noteTimer = null;
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        });
      }, 700);
    });
  }

  var termsBox = document.getElementById('cartTermsCheckbox');
  var checkoutBtn = document.getElementById('cartCheckoutBtn');
  var termsWrap = document.getElementById('cartTermsWrap');
  if (termsBox && termsWrap) {
    termsBox.addEventListener('change', function () {
      if (termsBox.checked) termsWrap.classList.remove('has-error');
    });
  }
});

/* ---------------- quick add to cart from product cards ---------------- */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-quick-add]');
  if (!btn || btn.disabled) return;
  var variantId = btn.getAttribute('data-quick-add');
  if (!variantId) return;
  var originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Aggiunta…';
  EurotogaCart.addItemsAndGoToCart([{ id: variantId, quantity: 1 }]).catch(function () {
    toast('Non è stato possibile aggiungere al carrello.');
    btn.disabled = false;
    btn.textContent = originalText;
  });
});

/* ---------------- product configurator (toga) ---------------- */
var EUROTOGA_CORDONI_MAP = {
  avvocato: ['Argento e Nero', 'Argento e Nero VIP Lusso', 'Oro e Nero', 'Oro e Nero VIP Lusso'],
  magistrato: ['Oro', 'Argento', 'Rosso', 'Bianco']
};
var EUROTOGA_CORDONI_CHIPS = {
  'Argento e Nero': 'linear-gradient(90deg,#151311,#B9AF9B)',
  'Oro e Nero': 'linear-gradient(90deg,#151311,#A2793A)',
  'Argento e Nero VIP Lusso': 'linear-gradient(90deg,#151311,#B9AF9B,#151311)',
  'Oro e Nero VIP Lusso': 'linear-gradient(90deg,#151311,#A2793A,#151311)',
  'Oro': 'linear-gradient(90deg,#151311,#A2793A)',
  'Argento': 'linear-gradient(90deg,#151311,#B9AF9B)',
  'Rosso': 'linear-gradient(90deg,#151311,#5C1B22)',
  'Bianco': 'linear-gradient(90deg,#151311,#F7F2E7)'
};

document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('ProductConfiguratorData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  window.EurotogaMoneyFormat = data.moneyFormat;
  initConfigurator(data);
});

function initConfigurator(data) {
  var state = { genere: null, professione: data.isUditore ? 'uditore' : null, cordone: data.isUditore ? 'Argento' : null, taglia: '', altezza: '', peso: '', foto: [], fotoUploading: false, ricamo: data.isUditore ? true : null, ricamoTesto: '', pettorinaWanted: data.isUditore ? true : null, pettorina: null, note: '' };
  var stepsEl = document.getElementById('configuratorSteps');
  var summaryEl = document.getElementById('summaryBox');
  var mobileTotal = document.getElementById('mobileTotal');
  var mobileBtn = document.getElementById('mobileAddToCart');

  function effectiveCordone() {
    if (data.isUditore) return 'Argento';
    if (state.cordone) return state.cordone;
    if (state.professione && EUROTOGA_CORDONI_MAP[state.professione]) {
      return EUROTOGA_CORDONI_MAP[state.professione][0];
    }
    return null;
  }

  function findVariant() {
    if (!state.genere) return data.variants[0] || null;
    var matched = data.variants.filter(function (v) {
      return v.option1 === state.genere;
    })[0];
    return matched || data.variants[0] || null;
  }

  function findPettorina() {
    if (!state.pettorina) return null;
    return (data.pettorinaOptions || []).filter(function (p) { return String(p.id) === String(state.pettorina); })[0] || null;
  }

  function vipLussoInfo() {
    var c = effectiveCordone();
    if (!c || c.indexOf('VIP Lusso') === -1) return null;
    return (data.vipLussoByOption || {})[c] || null;
  }
  function total() {
    var variant = findVariant();
    var t = variant ? parseInt(variant.price, 10) : (data.variants.length ? parseInt(data.variants[0].price, 10) : 0);
    if (state.ricamo && data.ricamoPrice && !data.isUditore) t += parseInt(data.ricamoPrice, 10);
    var vipInfo = vipLussoInfo();
    if (vipInfo && vipInfo.price) t += parseInt(vipInfo.price, 10);
    var pett = findPettorina();
    if (pett && !data.isUditore) t += parseInt(pett.price, 10);
    return t;
  }

  function renderSteps() {
    var genereOptions = ['Uomo', 'Donna'];
    var html = '';

    // step 1 — gender
    var st = data.stepTexts || {};
    html += '<div class="config-step"><span class="num">Step 1</span><h4>' + escapeHtml(st.step1_title || 'Sesso') + '</h4>';
    html += '<div class="choice-row">';
    genereOptions.forEach(function (g) {
      html += '<button type="button" class="choice' + (state.genere === g ? ' selected' : '') + '" data-step="genere" data-value="' + g + '">' + g + '</button>';
    });
    html += '</div></div>';

    // step 2 — profession (UI filter)
    html += '<div class="config-step"><span class="num">Step 2</span><h4>' + escapeHtml(st.step2_title || 'Professione') + '</h4>';
    if (data.isUditore) {
      html += '<p class="hint">Questo kit è pensato per gli Uditori Giudiziari</p><div class="choice-row">' +
        '<button type="button" class="choice selected" disabled>Uditore Giudiziario</button></div>';
    } else {
      html += '<div class="choice-row">';
      ['avvocato', 'magistrato'].forEach(function (p) {
        var label = p === 'avvocato' ? 'Avvocato' : 'Magistrato';
        html += '<button type="button" class="choice' + (state.professione === p ? ' selected' : '') + '" data-step="professione" data-value="' + p + '">' + label + '</button>';
      });
      html += '</div>';
      // "Lavorazione": craft note about the hand-made pleating on the back,
      // shown right here once a profession is chosen (not as its own step).
      // Photo depends on which profession: avvocato = velvet collar band,
      // magistrato = plain collar (same photo used for the Uditore).
      if (state.professione) {
        var lavorazioneImg = state.professione === 'magistrato' ? data.lavorazioneImageMagistrato : data.lavorazioneImageAvvocato;
        html += '<div class="field-label-row" style="align-items:center; margin-top:14px;">' +
          '<p style="flex:1; margin:0; font-family:var(--serif); font-style:normal; font-size:16px; color:var(--ink); line-height:1.5;">Toga su misura con arricciatura a cannoncini, realizzata a mano</p>' +
          fieldInfoHtml('lavorazione', (lavorazioneImg ? '<img src="' + lavorazioneImg + '" alt="Dettaglio arricciatura a cannoncini">' : ''), '') +
          '</div>';
      }
    }
    html += '</div>';

    // step 3 — cords
    html += '<div class="config-step"><span class="num">Step 3</span><h4>' + escapeHtml(st.step3_title || 'Cordoni') + '</h4>';
    if (data.isUditore) {
      var uditoreDetail = (data.cordoniDetails || {})['Argento'];
      var uditoreThumb = uditoreDetail && uditoreDetail.image ? '<img src="' + uditoreDetail.image + '" alt="Argento" class="chip-photo">' : '<span class="chip" style="background:' + (EUROTOGA_CORDONI_CHIPS['Argento'] || 'var(--stone-light)') + ';"></span>';
      html += '<p class="hint">Cordoni argento inclusi nel kit.</p><div class="choice-row">' +
        '<button type="button" class="swatch-choice selected" disabled>' + uditoreThumb +
        '<span class="meta"><b>Argento — Uditore Giudiziario</b><small>Incluso</small></span></button></div>';
    } else if (state.professione) {
      var opts = EUROTOGA_CORDONI_MAP[state.professione] || [];
      html += '<div class="choice-row">';
      opts.forEach(function (c) {
        var isVip = c.indexOf('VIP Lusso') !== -1;
        var vipData = isVip ? (data.vipLussoByOption || {})[c] : null;
        var priceLabel = isVip
          ? (vipData && vipData.price ? '+ ' + euroClean(vipData.price).replace(' €', '€') + ' + IVA' : 'Supplemento')
          : 'Inclusi';
        var detail = (data.cordoniDetails || {})[c];
        var thumb = detail && detail.image ? '<img src="' + detail.image + '" alt="' + c + '" class="chip-photo">' : '<span class="chip" style="background:' + (EUROTOGA_CORDONI_CHIPS[c] || 'var(--stone-light)') + ';"></span>';
        html += '<button type="button" class="swatch-choice' + (state.cordone === c ? ' selected' : '') + '" data-step="cordone" data-value="' + c + '">' +
          thumb +
          '<span class="meta"><b>' + (detail ? detail.fullLabel : c) + '</b><small>' + priceLabel + '</small></span></button>';
      });
      html += '</div>';
    } else {
      html += '<p class="hint">Seleziona prima la professione allo step 2</p>';
    }
    html += '</div>';

    // step 4 — free porta-toga bag (always included, informational only, no user choice)
    html += '<div class="config-step"><span class="num">Step 4</span><div class="field-label-row"><h4 style="margin:0;">Inclusa borsetta porta toga con manici in tessuto TNT <span class="gift-tag">in omaggio</span></h4>' +
      fieldInfoHtml('portatoga', (data.portaTogaImage ? '<img src="' + data.portaTogaImage + '" alt="Borsetta porta toga">' : ''), '') +
      '</div></div>';

    // step 6 — measurements (required flag + values configurable from Admin, see data.misure)
    var misureCfg = data.misure || {};
    var taglieCfg = misureCfg.taglia || { required: true, options: [] };
    var altezzaCfg = misureCfg.altezza || { required: true, options: [] };
    var pesoCfg = misureCfg.peso || { required: true, options: [] };
    var taglieLabel = 'Taglia giacca' + (taglieCfg.required ? '' : ' (facoltativo)');
    var altezzaLabel = 'Altezza (cm)' + (altezzaCfg.required ? '' : ' (facoltativo)');
    var pesoLabel = 'Peso (kg)' + (pesoCfg.required ? '' : ' (facoltativo)');
    html += '<div class="config-step"><span class="num">Step 5</span><h4>' + escapeHtml(st.step4_title || 'Le tue misure') + '</h4>';
    html += '<div class="field-row">';
    html += '<div class="field"><div class="field-label-row"><label for="cfgTaglia">' + taglieLabel + '</label>' +
      fieldInfoHtml('taglia', '<img src="' + data.shoulderImageUrl + '" alt="Misurazione da spalla a spalla">', 'Misura in centimetri da spalla a spalla, come nella foto') +
      '</div><select id="cfgTaglia">' + selectOptionsFromList(taglieCfg.options, state.taglia, 'Taglia') + '</select></div>';
    html += '<div class="field"><div class="field-label-row"><label for="cfgAltezza">' + altezzaLabel + '</label>' +
      fieldInfoHtml('altezza', '<div class="height-illustration">' + heightIllustrationSVG() + '</div>', 'Altezza totale della persona, misurata da testa a piedi') +
      '</div><select id="cfgAltezza">' + selectOptionsFromList(altezzaCfg.options, state.altezza, 'Altezza') + '</select></div>';
    html += '</div>';
    html += '<div class="field" style="margin-top:14px; max-width:220px;"><label for="cfgPeso">' + pesoLabel + '</label><select id="cfgPeso">' + selectOptionsFromList(pesoCfg.options, state.peso, 'Peso') + '</select></div>';
    html += '<button type="button" class="help-link" onclick="EurotogaMeasureGuide.open()">Guarda il video su come prendere correttamente le misure</button>';
    var uploadLabelText = state.fotoUploading ? 'Caricamento in corso…' : 'Hai dubbi? Carica una o più foto della misurazione delle spalle.';
    html += '<label class="upload-box" id="uploadBox" for="cfgFoto">' +
      '<div id="uploadLabel">' + uploadLabelText + '</div>' +
      '<input type="file" id="cfgFoto" accept="image/*" multiple ' + (state.fotoUploading ? 'disabled' : '') + '></label>';
    if (state.foto.length > 0) {
      html += '<div class="photo-list">';
      state.foto.forEach(function (f, i) {
        var statusText = f.uploading ? 'Caricamento…' : (f.url ? 'Caricata' : 'Errore, riprova');
        html += '<div class="photo-item' + (f.url ? ' ok' : '') + '"><span>' + f.name + ' — ' + statusText + '</span>' +
          '<button type="button" class="rm" data-remove-photo="' + i + '">Rimuovi</button></div>';
      });
      html += '</div>';
    }
    html += '</div>';

    // step 5 — embroidery
    html += '<div class="config-step"><span class="num">Step 6</span><h4>' + escapeHtml(st.step5_title || 'Personalizza la tua toga') + '</h4><p class="hint">' + escapeHtml(st.step5_hint || 'Ricamo del nome e cognome all\'interno della toga') + (data.isUditore ? ' — incluso nel kit' : '') + '</p>';
    if (!data.isUditore) {
      html += '<div class="choice-row">';
      html += '<button type="button" class="choice' + (state.ricamo === true ? ' selected' : '') + '" data-step="ricamo" data-value="si">Sì' + (data.ricamoPrice ? ' (+ ' + euroClean(data.ricamoPrice).replace(' €', '€') + ' + IVA)' : '') + '</button>';
      html += '<button type="button" class="choice' + (state.ricamo === false ? ' selected' : '') + '" data-step="ricamo" data-value="no">No</button>';
      html += '</div>';
    }
    if (state.ricamo) {
      var ricamoExample = data.isUditore ? 'Mario Rossi' : (state.professione === 'magistrato' ? 'Mario Rossi' : 'Avv. Mario Rossi');
      html += '<div id="embroideryField" style="margin-top:14px;"><div class="field"><label for="cfgRicamoTesto">Testo ricamo</label><input type="text" id="cfgRicamoTesto" placeholder="' + ricamoExample + '" value="' + state.ricamoTesto + '"></div>' +
        '<div class="embroidery-preview" id="embroideryPreview">' + (state.ricamoTesto || ricamoExample) + '</div></div>';
    }
    html += '</div>';

    // step 6 — pettorina/bib (Yes/No, then priced options if Yes)
    html += '<div class="config-step"><span class="num">Step 7</span><h4>' + escapeHtml(st.step6_title || 'Pettorina') + '</h4>';
    if (data.isUditore) {
      html += '<p class="hint">Inclusa nel kit, nessun supplemento — scegli il modello</p><div class="pettorina-grid">';
      if ((data.pettorinaOptions || []).length === 0) {
        html += '<p class="hint" style="grid-column:1/-1;">Nessun prodotto trovato nella collezione "pettorine" — verifica che esista con questo handle esatto e contenga dei prodotti</p>';
      }
      (data.pettorinaOptions || []).forEach(function (p) {
        html += '<button type="button" class="pettorina-choice' + (String(state.pettorina) === String(p.id) ? ' selected' : '') + (p.available ? '' : ' unavailable') + '" data-step="pettorina" data-value="' + p.id + '" ' + (p.available ? '' : 'disabled') + '>' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '<span class="ph"></span>') +
          '<span class="price">' + (p.available ? 'Inclusa' : 'Non disponibile') + '</span></button>';
      });
      html += '</div>';
    } else {
      html += '<div class="choice-row">';
      html += '<button type="button" class="choice' + (state.pettorinaWanted === true ? ' selected' : '') + '" data-step="pettorinaWanted" data-value="si">Sì' + (data.pettorinaPrice ? ' (+ ' + euroClean(data.pettorinaPrice).replace(' €', '€') + ' + IVA)' : '') + '</button>';
      html += '<button type="button" class="choice' + (state.pettorinaWanted === false ? ' selected' : '') + '" data-step="pettorinaWanted" data-value="no">No</button>';
      html += '</div>';
      if (state.pettorinaWanted) {
        html += '<p class="hint" style="margin-top:14px;">Scegli il modello</p><div class="pettorina-grid">';
        if ((data.pettorinaOptions || []).length === 0) {
          html += '<p class="hint" style="grid-column:1/-1;">Nessun prodotto trovato nella collezione "pettorine" — verifica che esista con questo handle esatto e contenga dei prodotti</p>';
        }
        (data.pettorinaOptions || []).forEach(function (p) {
          html += '<button type="button" class="pettorina-choice' + (String(state.pettorina) === String(p.id) ? ' selected' : '') + (p.available ? '' : ' unavailable') + '" data-step="pettorina" data-value="' + p.id + '" ' + (p.available ? '' : 'disabled') + '>' +
            (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '<span class="ph"></span>') +
            (p.available ? '' : '<span class="price">Non disponibile</span>') + '</button>';
        });
        html += '</div>';
      }
    }
    html += '</div>';

    // step 7 — notes
    html += '<div class="config-step"><span class="num">Step 8</span><h4>' + escapeHtml(st.step7_title || 'Note per la sartoria') + '</h4><p class="hint">' + escapeHtml(st.step7_hint || 'Facoltative — indicazioni particolari su misure, tessuto o consegna') + '</p>' +
      '<textarea id="cfgNote" rows="3" style="width:100%; padding:11px 12px; border:1px solid var(--line); background:var(--paper); font-family:var(--sans); font-size:14px;">' + state.note + '</textarea></div>';

    // assistance box
    html += '<div class="config-step" style="border-bottom:1px solid var(--line);"><span class="num">Assistenza</span><h4>' + escapeHtml(st.assistance_title || 'Hai dubbi sulla configurazione?') + '</h4>' +
      '<p class="hint" style="margin-bottom:14px;">' + escapeHtml(st.assistance_hint || 'Parla con la sartoria in ogni fase del tuo ordine') + '</p>' +
      '<a class="btn btn-secondary btn-sm" href="https://wa.me/' + (window.EurotogaWhatsapp || '393791234762') + '" target="_blank" rel="noopener">Chatta con noi su WhatsApp</a></div>';

    stepsEl.innerHTML = html;
    bindStepEvents();
  }

  function bindStepEvents() {
    bindFieldInfoToggles(stepsEl);
    qsa('[data-step]', stepsEl).forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step');
        var value = btn.getAttribute('data-value');
        if (step === 'genere') { state.genere = value; state.cordone = data.isUditore ? 'Argento' : null; }
        if (step === 'professione') { state.professione = value; state.cordone = data.isUditore ? 'Argento' : null; }
        if (step === 'cordone') { state.cordone = value; }
        if (step === 'ricamo') { state.ricamo = value === 'si'; }
        if (step === 'pettorinaWanted') { state.pettorinaWanted = value === 'si'; if (!state.pettorinaWanted) state.pettorina = null; }
        if (step === 'pettorina') { state.pettorina = value || null; }
        renderSteps();
        renderSummary();
      });
    });
    var t = document.getElementById('cfgTaglia'); if (t) t.addEventListener('change', function () { state.taglia = t.value; renderSummary(); });
    var a = document.getElementById('cfgAltezza'); if (a) a.addEventListener('change', function () { state.altezza = a.value; renderSummary(); });
    var p = document.getElementById('cfgPeso'); if (p) p.addEventListener('change', function () { state.peso = p.value; renderSummary(); });
    var rt = document.getElementById('cfgRicamoTesto'); if (rt) rt.addEventListener('input', function () {
      state.ricamoTesto = rt.value;
      var preview = document.getElementById('embroideryPreview');
      if (preview) preview.textContent = state.ricamoTesto || (data.isUditore ? 'Mario Rossi' : (state.professione === 'magistrato' ? 'Mario Rossi' : 'Avv. Mario Rossi'));
      renderSummary();
    });
    var foto = document.getElementById('cfgFoto');
    if (foto) foto.addEventListener('change', function () {
      var files = foto.files ? Array.prototype.slice.call(foto.files) : [];
      if (!files.length) return;
      state.fotoUploading = true;
      var startIndex = state.foto.length;
      files.forEach(function (file) {
        state.foto.push({ name: file.name, url: '', uploading: true });
      });
      renderSteps();
      renderSummary();
      var pending = files.length;
      files.forEach(function (file, i) {
        var entry = state.foto[startIndex + i];
        uploadToImgBB(file).then(function (url) {
          entry.url = url;
        }).catch(function () {
          entry.url = '';
        }).finally(function () {
          entry.uploading = false;
          pending--;
          if (pending === 0) state.fotoUploading = false;
          renderSteps();
          renderSummary();
        });
      });
      foto.value = '';
    });
    qsa('[data-remove-photo]', stepsEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-remove-photo'), 10);
        state.foto.splice(idx, 1);
        renderSteps();
        renderSummary();
      });
    });
    var note = document.getElementById('cfgNote');
    if (note) note.addEventListener('input', function () { state.note = note.value; renderSummary(); });
  }

  function renderSummary() {
    var variant = findVariant();
    var pett = findPettorina();
    var lines = [];
    lines.push(row('Modello', data.title, true));
    lines.push(row('Professione', state.professione === 'avvocato' ? 'Avvocato' : state.professione === 'magistrato' ? 'Magistrato' : state.professione === 'uditore' ? 'Uditore Giudiziario' : null, false, 'da scegliere'));
    lines.push(row('Genere', state.genere, false, 'da scegliere'));
    var cordoneValue = data.isUditore ? effectiveCordone() : state.cordone;
    var cordoneDetail = cordoneValue ? (data.cordoniDetails || {})[cordoneValue] : null;
    var cordoneDisplay = data.isUditore ? 'Argento — Uditore Giudiziario (inclusi)' : (cordoneValue ? (cordoneDetail ? cordoneDetail.fullLabel : cordoneValue) : null);
    var vipInfoForSummary = vipLussoInfo();
    if (cordoneDisplay && vipInfoForSummary && vipInfoForSummary.price) cordoneDisplay += ' (+ ' + euroClean(vipInfoForSummary.price).replace(' €', '€') + ' + IVA)';
    lines.push(row('Cordoni', cordoneDisplay, false, 'da scegliere'));
    lines.push(row('Borsetta porta toga', 'Con manici in tessuto TNT (in omaggio)', true));
    lines.push(row('Taglia giacca', state.taglia, false, 'da inserire'));
    lines.push(row('Altezza', state.altezza, false, 'da inserire'));
    lines.push(row('Peso', state.peso, false, 'da inserire'));
    var fotoCaricate = state.foto.filter(function (f) { return f.url; }).length;
    if (fotoCaricate > 0) {
      lines.push(row('Foto misurazione', fotoCaricate === 1 ? 'Caricata' : fotoCaricate + ' caricate', true));
    }
    var ricamoSummary = state.ricamo === null ? null : (state.ricamo ? (state.ricamoTesto || 'Sì') : 'No');
    if (ricamoSummary && state.ricamo && data.ricamoPrice && !data.isUditore) { ricamoSummary += ' (+ ' + euroClean(data.ricamoPrice).replace(' €', '€') + ' + IVA)'; }
    lines.push(row('Ricamo', ricamoSummary, true, 'da scegliere'));
    var pettorinaSummary;
    if (data.isUditore) { pettorinaSummary = pett ? pett.title + ' (inclusa nel kit)' : null; }
    else if (state.pettorinaWanted === null) { pettorinaSummary = null; }
    else if (state.pettorinaWanted) {
      pettorinaSummary = pett ? pett.title : null;
      if (pettorinaSummary && pett.price) { pettorinaSummary += ' (+ ' + euroClean(pett.price).replace(' €', '€') + ' + IVA)'; }
    }
    else { pettorinaSummary = 'No'; }
    lines.push(row('Pettorina', pettorinaSummary, true, 'da scegliere'));
    if (state.note) lines.push(row('Note', state.note, true));

    var netTotal = total();

    var isComplete = validateConfig().length === 0;
    var html = '<div class="sh">Riepilogo della tua toga</div><div class="summary-lines">' + lines.join('') + '</div>' +
      '<div class="summary-total"><span>Totale</span><span class="amt" style="white-space:nowrap;">' + euroClean(netTotal).replace(' €', '€') + ' + IVA</span></div>' +
      '<div class="summary-cta"><button type="button" class="btn btn-primary btn-block' + (isComplete ? '' : ' btn-muted') + '" id="addToCartBtn">Aggiungi al carrello</button></div>';
    summaryEl.innerHTML = html;
    if (mobileTotal) mobileTotal.textContent = euroClean(total()).replace(' €', '€') + ' + IVA';

    var btn = document.getElementById('addToCartBtn');
    if (btn) btn.addEventListener('click', addToCart);
    if (mobileBtn) {
      mobileBtn.classList.toggle('btn-muted', !isComplete);
      mobileBtn.onclick = addToCart;
    }
  }

  function row(label, value, alwaysShown, placeholder) {
    var display = value || ('— ' + (placeholder || 'da scegliere'));
    return '<div class="row' + (value ? '' : ' empty') + '"><span>' + label + '</span><b>' + display + '</b></div>';
  }

  function validateConfig() {
    var missing = [];
    var misureCfg = data.misure || {};
    var taglieCfg = misureCfg.taglia || { required: true };
    var altezzaCfg = misureCfg.altezza || { required: true };
    var pesoCfg = misureCfg.peso || { required: true };
    if (!state.genere) missing.push('il sesso');
    if (!state.professione) missing.push('la professione');
    if (!state.cordone) missing.push('i cordoni');
    if (taglieCfg.required && !state.taglia) missing.push('la taglia giacca');
    if (altezzaCfg.required && !state.altezza) missing.push('l\'altezza');
    if (pesoCfg.required && !state.peso) missing.push('il peso');
    if (!data.isUditore) {
      if (state.ricamo === null) missing.push('se vuoi il ricamo (sì o no)');
      else if (state.ricamo && !state.ricamoTesto) missing.push('il testo del ricamo');
    }
    if (!data.isUditore) {
      if (state.pettorinaWanted === null) missing.push('se vuoi la pettorina (sì o no)');
    }
    if (state.pettorinaWanted && !state.pettorina) missing.push('il modello di pettorina');
    return missing;
  }

  function addToCart() {
    var missing = validateConfig();
    if (missing.length) {
      toast('Ci manca ancora ' + missing[0] + ' per completare la configurazione.');
      return;
    }
    var variant = findVariant();
    if (!variant) { toast('Questa combinazione non è al momento disponibile.'); return; }
    var linkId = 'toga-' + Date.now();
    var cordoneFinal = effectiveCordone();
    var cordoneFinalDetail = cordoneFinal ? (data.cordoniDetails || {})[cordoneFinal] : null;
    var cordoneFinalLabel = data.isUditore ? 'Argento — Uditore Giudiziario' : (cordoneFinalDetail ? cordoneFinalDetail.fullLabel : (cordoneFinal || ''));
    var props = {
      'Genere': state.genere || '',
      'Professione': state.professione === 'avvocato' ? 'Avvocato' : state.professione === 'magistrato' ? 'Magistrato' : state.professione === 'uditore' ? 'Uditore Giudiziario' : '',
      'Cordoni': cordoneFinalLabel,
      '_link_id': linkId,
      '_main': 'true'
    };
    if (!data.isUditore) { props['Borsetta porta toga'] = 'Con manici in tessuto TNT (in omaggio)'; }
    props['Taglia giacca'] = state.taglia;
    props['Altezza'] = state.altezza || '';
    props['Peso'] = state.peso || '';
    var fotoCaricateOk = state.foto.filter(function (f) { return f.url; });
    if (fotoCaricateOk.length === 1) {
      props['Foto misurazione'] = fotoCaricateOk[0].url;
    } else if (fotoCaricateOk.length > 1) {
      fotoCaricateOk.forEach(function (f, i) { props['Foto misurazione ' + (i + 1)] = f.url; });
    }
    if (data.isUditore) {
      props['Ricamo incluso'] = 'Sì';
      if (state.ricamoTesto) { props['Testo ricamo'] = state.ricamoTesto; }
    } else {
      props['Ricamo'] = state.ricamo ? (state.ricamoTesto || 'Sì') : 'No';
    }
    var pett = findPettorina();
    if (pett) {
      if (data.isUditore) {
        // Included in the kit: informational order property only, no surcharge line item.
        props['Pettorina'] = pett.title + ' (inclusa nel kit)';
      } else {
        props['Pettorina'] = pett.title;
      }
    } else if (!data.isUditore) {
      props['Pettorina'] = 'No';
    }
    if (state.note) props['Note'] = state.note;

    var items = [{ id: variant.id, quantity: 1, properties: props }];
    if (state.ricamo && data.ricamoVariantId && !data.isUditore) {
      items.push({ id: data.ricamoVariantId, quantity: 1, properties: { '_link_id': linkId, '_row_label': 'Ricamo del nome e cognome', '_kind': 'ricamo', 'Per': state.ricamoTesto || '' } });
    }
    var vipInfoForCart = vipLussoInfo();
    if (vipInfoForCart && vipInfoForCart.variantId) {
      items.push({ id: vipInfoForCart.variantId, quantity: 1, properties: { '_link_id': linkId, '_row_label': cordoneFinalDetail ? cordoneFinalDetail.fullLabel : effectiveCordone(), '_kind': 'cordoni_vip' } });
    }
    if (pett && !data.isUditore) {
      items.push({ id: pett.id, quantity: 1, properties: { '_link_id': linkId, '_row_label': pett.title, '_kind': 'pettorina' } });
    }

    EurotogaCart.addItemsAndGoToCart(items).catch(function () {
      toast('Non è stato possibile aggiungere al carrello. Verifica le varianti configurate su questo prodotto.');
    });
  }

  renderSteps();
  renderSummary();
}
